export default [
  {
    title: 'Benvinguda',
    element: 'body',
    text: 'Benvingut a Idonia, la teva plataforma mèdica d\'intercanvi d\'imatges. En aquesta visita us ajudarem a començar.',
    placement: {
      relativeTo: 'viewport',
      position: 'bottom right'
    }
  },
  {
    title: 'Mi Espai',
    element: '.idonia-header .toolbar__title',
    text: 'A "My Space" trobareu tota la vostra carpeta, documents i estudis emmagatzemats a Idonia.',
    placement: {
      relativeTo: 'element',
      position: 'bottom left'
    }
  },
  {
    title: '"+" Botó',
    element: '.action-fab button',
    text: 'Utilitzeu aquest menú per crear una carpeta, carregueu un fitxer o una carpeta des del vostre dispositiu.',
    placement: {
      relativeTo: 'element',
      position: 'top right'
    }
  },
  {
    title: 'Fitxers compartits',
    element: 'a[data-name="shared"]',
    text: 'A "compartit amb mi" podràs veure els casos que la SERAM ha compartit amb tu així com altres arxius i carpetes compartits per altres usuaris.',
    placement: {
      relativeTo: 'element',
      position: 'right bottom'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/mobile/ca-ES/seram2018.js